module.exports = __webpack_public_path__ + "static/media/albert-einstein.0a681f61.jpg";